export default __webpack_public_path__ + "static/media/plain-sticker-W.bab90329.png";